import React, { Component } from "react";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";
import userMarker from "../../map_marker_user.png";
import trashMarker from "../../map_marker_trash.png";

export class MapContainer extends Component {
  render() {
    return (
      <Map
        google={this.props.google}
        zoom={14}
        style={{
          height: "59vh",
          width: "100vw"
        }}
        initialCenter={this.props.location}
        center={this.props.location}
      >
        <Marker
          title={"You are here"}
          name={"You"}
          position={this.props.location}
          icon={{
            url: userMarker,
            anchor: this.props.google.maps.Point(32, 32),
            scaledSize: this.props.google.maps.Size(1, 1)
          }}
        />
        {this.props.bounties &&
          this.props.bounties.map(bounty => {
            return (
              <Marker
                title={"title"}
                name={bounty.title}
                position={{
                  lat: bounty.location && bounty.location._latitude,
                  lng: bounty.location && bounty.location._longitude
                }}
                icon={{
                  url: trashMarker,
                  anchor: this.props.google.maps.Point(32, 32),
                  scaledSize: this.props.google.maps.Size(1, 1)
                }}
              />
            );
          })}
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
  style: {
    height: "59vh"
  }
})(MapContainer);
